import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IEntityInfo } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class EntitiesService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/entities`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string): Observable<IEntityInfo[]> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<IEntityInfo[]>(baseRoute);
  }
}
